import React from 'react';
import { Link } from 'react-router-dom';
import { absoluteAsset } from '../services/api';

/**
 * Brand sub-divider used inside a category section to group products by brand.
 * Smaller and more subtle than CategorySectionHeader.
 */
const BrandSubHeader = ({ brand, brandId, logo, count }) => {
  const content = (
    <div className="flex items-center gap-3">
      {logo ? (
        <div className="flex h-10 w-16 shrink-0 items-center justify-center overflow-hidden rounded-md border border-slate-200 bg-white p-1">
          <img src={absoluteAsset(logo)} alt={brand} className="h-full w-full object-contain" />
        </div>
      ) : (
        <div className="h-6 w-1 rounded-full bg-emerald-500" />
      )}
      <h3 className="text-lg font-semibold text-slate-800">{brand}</h3>
      {typeof count === 'number' && (
        <span className="rounded-full bg-slate-100 px-2.5 py-0.5 text-xs font-medium text-slate-600">
          {count}
        </span>
      )}
    </div>
  );

  return (
    <div className="mb-4 mt-2 flex items-center gap-3">
      <div className="h-px w-6 bg-emerald-300" />
      {brandId ? (
        <Link
          to={`/brands/${brandId}`}
          className="group flex-1 transition-colors hover:text-emerald-800"
        >
          {content}
        </Link>
      ) : (
        <div className="flex-1">{content}</div>
      )}
      <div className="h-px flex-1 bg-emerald-100" />
    </div>
  );
};

export default BrandSubHeader;
